import {promiseRequest} from '../util/promiseRequest'

const API_VERSION = 'v1'

export function logout(): Promise<boolean> {
  return promiseRequest<boolean>(`https://api.${process.env.host}/${API_VERSION}/auth/logout`, {
    method: 'POST',
  }).then(() => true)
}
